import * as React from "react"
import * as i18n from "tb-i18n"
import { getRegisterUrl } from "../homepage.module"
import { formLink } from "app/utils"
const style = require("./main.styl")

export default class SignUpPanel extends React.PureComponent {
    constructor(prop) {
        super(prop)
    }
    render() {
        return (
            <div className={ style["wrap-sign-in-panel"] }>
                <div className={ style["sign-in-panel"] }>
                    <div className="sign-in-panel-title">
                        {i18n.get("homepage.signUp.title")}
                    </div>
                    <div className="sign-in-panel-desc">
                        {i18n.get("homepage.signUp.desc")}
                    </div>
                    <div className="sign-in-panel-buttons">
                        <a
                            className="btn btn-gradient-blue free-signup"
                            href={ getRegisterUrl("home") }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {i18n.get("homepage.register.button")}
                        </a>
                        <a
                            className="btn btn-gradient-ghost consult-help"
                            href={ formLink("demo_homepage") }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {i18n.get("business.consulting.help")}
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}
